// import dbAxios from "../../configurations/axios";

// export const validateLogin = async (username, password) => {
// 	let booled = false;

// 	if (username.toLowerCase() === "geomatics") {
// 		await dbAxios
// 			.post("/login/setter/", { username, password })
// 			.then((response) => {
// 				if (response.status === "Ok") {
// 					booled = response;
// 				}
// 			})
// 			.catch(() => {});
// 	}

// 	return booled;
// };

const validateLogin = (username, password) => {
	if (
		username.trim().toLowerCase() === "geomatics" &&
		password.trim() === "gap@1234"
	) {
		return {
			data: {
				username: "geomatics",
				email: "geomatics@zameen.com",
				id: 1,
			},
		};
	} else if (
		username.trim().toLowerCase() === "sales" &&
		password.trim() === "welcome@1234"
	) {
		return {
			data: {
				username: "sales",
				email: "sales@zameen.com",
				id: 2,
			},
		};
	} else return false;
};

export { validateLogin };
